export const categories = [
  {
    slug: "shouban",
    name: "手办周边",
    description: "精选白丝JK角色高品质手办，包含景品、比例手办、黏土人等各类正版周边产品",
    icon: "ri-shapes-line",
    image: "https://readdy.ai/api/search-image?query=Anime%20figure%20display%20with%20schoolgirl%20uniform%20white%20stockings%20character%2C%20clean%20display%20shelf%2C%20soft%20pink%20and%20white%20aesthetic%20background%2C%20professional%20product%20photography%2C%20delicate%20details%2C%20warm%20lighting%2C%20collector%20display%20style&width=800&height=600&seq=cat-shouban&orientation=landscape",
  },
  {
    slug: "fuzhuang",
    name: "JK服装",
    description: "正版JK制服白丝搭配方案，包含上衣、裙子、白丝袜、小物配饰等完整穿搭指南",
    icon: "ri-t-shirt-line",
    image: "https://readdy.ai/api/search-image?query=Japanese%20school%20uniform%20JK%20fashion%20with%20white%20knee%20socks%2C%20clean%20minimal%20layout%2C%20soft%20pastel%20pink%20and%20cream%20background%2C%20flat%20lay%20clothing%20photography%2C%20elegant%20presentation%2C%20gentle%20natural%20lighting&width=800&height=600&seq=cat-fuzhuang&orientation=landscape",
  },
  {
    slug: "tongren",
    name: "同人文化",
    description: "白丝JK同人画集、同人志、插画作品及Cosplay写真集等二次创作文化内容",
    icon: "ri-palette-line",
    image: "https://readdy.ai/api/search-image?query=Anime%20doujin%20artwork%20illustration%20collection%20featuring%20school%20uniform%20characters%2C%20artistic%20style%2C%20warm%20pastel%20tones%2C%20creative%20layout%2C%20soft%20textured%20paper%20background%2C%20aesthetic%20composition&width=800&height=600&seq=cat-tongren&orientation=landscape",
  },
  {
    slug: "gouwu",
    name: "购物指南",
    description: "白丝JK周边购买渠道推荐、正版鉴别技巧、价格对比及新人入门选购攻略",
    icon: "ri-shopping-bag-3-line",
    image: "https://readdy.ai/api/search-image?query=Shopping%20guide%20layout%20with%20anime%20merchandise%20items%2C%20neat%20product%20arrangement%2C%20soft%20cream%20and%20blush%20pink%20background%2C%20organized%20desk%20scene%2C%20warm%20cozy%20lighting%2C%20lifestyle%20flat%20lay%20photography&width=800&height=600&seq=cat-gouwu&orientation=landscape",
  },
];

export const articles = [
  {
    slug: "shiroi-socks-jk-shouban-top10",
    title: "2026年白丝JK手办人气TOP10推荐",
    category: "shouban",
    summary: "盘点本年度最受欢迎的白丝JK角色手办，从景品到高端比例手办一应俱全，助你挑选心仪收藏品。",
    content: `
      <h3>白丝JK手办市场概况</h3>
      <p>近年来，随着二次元文化的蓬勃发展，白丝JK角色手办已经成为收藏市场上的热门品类。无论是经典校园番剧中的女主角，还是原创插画中的人气形象，只要搭配了标志性的白色过膝袜造型，往往都能引发一阵购买热潮。</p>
      <p>2026年，各大手办厂商纷纷推出了以白丝JK为主题的新品，从价格亲民的景品到精细度极高的比例手办，选择相当丰富。</p>

      <h3>TOP 1：雪之下雪乃 白丝限定版</h3>
      <p>由GSC出品的1/7比例手办，高度还原了雪之下雪乃在校园场景中的经典姿态。白色过膝袜的褶皱细节处理极为精致，搭配深色制服形成强烈的视觉对比。预售价约15,800日元，预计2026年第三季度出货。</p>

      <h3>TOP 2：原创角色「桜の約束」白丝JK</h3>
      <p>由知名插画师监修的原创角色手办，采用1/8比例。白丝部分使用半透明材质呈现若隐若现的肌肤质感，整体涂装工艺堪称一流。售价约12,000日元。</p>

      <h3>TOP 3：古见硝子 白丝Ver.</h3>
      <p>寿屋出品的古见硝子白丝版本手办，忠实还原了动画中的经典校服造型。表情刻画细腻温柔，白丝的材质表现自然。售价约9,800日元。</p>

      <h3>购买建议</h3>
      <p>选购白丝JK手办时，建议关注以下几点：首先确认是否为官方正版授权产品；其次注意手办的比例和材质说明；最后比较不同渠道的价格和运费。推荐通过Amiami、HobbySearch等日本直邮渠道购买，或者选择Bilibili会员购、Hpoi等国内正品渠道。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20display%20of%20anime%20girl%20figures%20in%20school%20uniforms%20with%20white%20stockings%2C%20collectible%20display%20cabinet%2C%20soft%20pink%20and%20cream%20backdrop%2C%20professional%20product%20photography%2C%20detailed%20closeup%2C%20warm%20ambient%20lighting&width=1200&height=675&seq=article-shouban-top10&orientation=landscape",
    date: "2026-07-15",
    author: "JK周边编辑部",
    tags: ["手办", "白丝", "JK", "排行", "收藏"],
  },
  {
    slug: "jk-uniform-white-socks-guide",
    title: "JK制服白丝搭配完全指南：从入门到精通",
    category: "fuzhuang",
    summary: "详解JK制服与白丝袜的搭配技巧，涵盖不同季节、场合的穿搭方案，以及丝袜材质、长度的选择攻略。",
    content: `
      <h3>白丝在JK文化中的地位</h3>
      <p>白丝过膝袜（ニーハイソックス）是JK制服文化中最具代表性的元素之一。它不仅仅是一件服饰单品，更是整个JK美学体系的重要组成部分。白色代表着纯真与青春，配合深色制服形成经典的黑白对比，营造出独特的视觉美感。</p>

      <h3>白丝的种类与选择</h3>
      <p>市面上的白丝袜主要分为以下几类：</p>
      <ul>
        <li><strong>纯棉白丝：</strong>透气性好，适合日常穿着，但弹性一般，容易起皱。</li>
        <li><strong>天鹅绒白丝：</strong>手感柔软细腻，光泽感强，拍照效果出色，但夏季较热。</li>
        <li><strong>包芯丝白丝：</strong>弹性极佳，贴合度高，透明度适中，是目前最受欢迎的类型。</li>
        <li><strong>蕾丝花边白丝：</strong>在袜口加入蕾丝装饰，增添甜美气息，适合约会或拍照场景。</li>
      </ul>

      <h3>长度搭配指南</h3>
      <p>白丝的长度选择直接影响整体造型效果：</p>
      <ul>
        <li><strong>过膝袜（Over Knee）：</strong>最经典的JK造型，袜口刚好在膝盖上方，露出"绝对领域"。</li>
        <li><strong>大腿袜（Thigh High）：</strong>长度延伸至大腿中部，搭配短裙效果出众。</li>
        <li><strong>及膝袜（Knee High）：</strong>刚好到膝盖，更偏向日常学院风。</li>
      </ul>

      <h3>品牌推荐</h3>
      <p>推荐几个品质可靠的白丝品牌：Tutuanna、ATSUGI厚木、Gunze郡是、以及国内口碑较好的觅雪工坊和樱花物语。购买时注意选择正规渠道，避免买到劣质仿品。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20school%20uniform%20fashion%20flat%20lay%20with%20white%20knee%20high%20socks%2C%20plaid%20skirt%2C%20sailor%20collar%2C%20soft%20cream%20and%20blush%20pink%20background%2C%20minimal%20aesthetic%20photography%2C%20clean%20composition%2C%20gentle%20natural%20light&width=1200&height=675&seq=article-uniform-guide&orientation=landscape",
    date: "2026-06-28",
    author: "JK周边编辑部",
    tags: ["JK制服", "白丝", "穿搭", "指南", "品牌"],
  },
  {
    slug: "doujin-culture-white-socks-jk",
    title: "白丝JK同人文化深度解析：从创作到收藏",
    category: "tongren",
    summary: "探索白丝JK在同人创作领域的独特魅力，了解同人志、插画、Cosplay等多元表现形式的发展脉络。",
    content: `
      <h3>同人文化的白丝JK现象</h3>
      <p>在日本的同人文化圈中，白丝JK是一个经久不衰的创作主题。从Comic Market到各种线上同人展，以白丝JK为主题的同人志和插画集始终保持着极高的人气。这一现象背后，折射出的是创作者和读者对青春校园美学的共同追忆与向往。</p>

      <h3>知名同人画师推荐</h3>
      <p>以下几位画师以白丝JK题材见长，作品兼具艺术性与收藏价值：</p>
      <ul>
        <li><strong>藤原</strong> —— 以华丽的光影处理和细腻的白丝质感著称，每届Comiket的新刊都供不应求。</li>
        <li><strong>森倉円</strong> —— 擅长捕捉少女的温柔神情，白丝JK系列插画集深受粉丝喜爱。</li>
        <li><strong>荻pote</strong> —— 以清新治愈的画风闻名，白丝JK作品充满日常温馨感。</li>
      </ul>

      <h3>同人志购买指南</h3>
      <p>购买白丝JK同人志的渠道主要有：Melonbooks、虎穴（Toranoana）、BOOTH、以及Pixiv的Fantia平台。对于不熟悉日文购买的国内用户，可以考虑通过代购或国内同人平台如B站工坊、CPP（COMICUP）等渠道入手。</p>

      <h3>Cosplay文化中的白丝JK</h3>
      <p>白丝JK也是Cosplay圈中的热门选题。一套完整的白丝JKCosplay通常包括：制服套装、白色过膝袜、乐福鞋、以及相应的假发和道具。知名Coser如Enako、伊织萌等都有精彩的JK白丝作品。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=Anime%20doujin%20art%20books%20and%20illustration%20collection%20display%2C%20colorful%20manga%20style%20covers%2C%20artistic%20creative%20atmosphere%2C%20soft%20warm%20lighting%2C%20wooden%20desk%20surface%2C%20cozy%20creative%20space%2C%20pastel%20tone%20background&width=1200&height=675&seq=article-doujin-culture&orientation=landscape",
    date: "2026-06-10",
    author: "JK周边编辑部",
    tags: ["同人", "白丝", "JK", "画师", "Cosplay"],
  },
  {
    slug: "genuine-vs-fake-identification",
    title: "白丝JK手办正版鉴别：5个关键技巧",
    category: "gouwu",
    summary: "学会快速识别白丝JK手办的真伪，从包装、涂装、底座到价格全面对比，避免买到山寨货。",
    content: `
      <h3>为什么要学会鉴别正版</h3>
      <p>随着白丝JK手办市场的火爆，仿冒品也层出不穷。购买到盗版手办不仅无法获得收藏价值，还可能出现涂装粗糙、材质劣质、甚至有害健康等问题。掌握以下5个鉴别技巧，帮你轻松避开假货。</p>

      <h3>技巧一：看包装盒</h3>
      <p>正版手办的包装盒印刷精细，色彩准确，盒子上通常有官方授权的镭射防伪标签。盗版包装往往存在色彩偏差、字体模糊、材质单薄等问题。特别注意盒子上的版权标识和制造商信息是否完整。</p>

      <h3>技巧二：检查涂装细节</h3>
      <p>白丝JK手办最考验涂装功力的就是白色丝袜部分。正版的白色涂装有自然的层次感和阴影过渡，而盗版往往是一片死白，缺乏立体感。同时注意检查发丝、眼睛、制服线条等细节是否有溢色或模糊。</p>

      <h3>技巧三：查看底座和编号</h3>
      <p>正版手办底座通常印有清晰的logo和产品编号，部分高端手办还有独立限量编号。盗版的底座做工粗糙，编号可能模糊不清或根本没有。</p>

      <h3>技巧四：价格对比</h3>
      <p>如果某款手办的售价远低于市场均价（通常是官方定价的50%以下），极有可能是仿品。建议在购买前先查询该手办的官方定价和主流渠道的售价范围。</p>

      <h3>技巧五：选择可靠渠道</h3>
      <p>最根本的防假方法是选择可靠的购买渠道。推荐渠道包括：日本直邮的Amiami、HobbySearch；国内的Bilibili会员购、Hpoi、电玩男；以及淘宝/京东上的品牌官方旗舰店。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=Magnifying%20glass%20examining%20anime%20figure%20details%2C%20authentication%20concept%2C%20clean%20white%20desk%20setup%2C%20warm%20cream%20and%20soft%20pink%20background%2C%20professional%20inspection%20scene%2C%20detailed%20closeup%20view%2C%20soft%20lighting&width=1200&height=675&seq=article-genuine-check&orientation=landscape",
    date: "2026-05-20",
    author: "JK周边编辑部",
    tags: ["正版鉴别", "手办", "购买指南", "防骗"],
  },
  {
    slug: "shiroi-jk-limited-edition-2026",
    title: "2026夏季白丝JK限定周边发售日历",
    category: "shouban",
    summary: "整理2026年夏季即将发售的白丝JK限定周边产品，包含手办、挂画、亚克力立牌等，提前掌握发售时间。",
    content: `
      <h3>2026夏季新品前瞻</h3>
      <p>2026年夏季，各大厂商蓄势待发，多款白丝JK主题的限定周边即将登场。我们整理了目前已知的发售信息，帮助各位提前做好购买规划。</p>

      <h3>6月发售</h3>
      <ul>
        <li><strong>《青春ブタ野郎》桜島麻衣 白丝浴衣Ver.</strong> —— Aniplex+限定，1/7比例，22,000日元，6月下旬出货。</li>
        <li><strong>原创角色「水無月の少女」白丝JK</strong> —— Native出品，1/6比例，18,800日元，6月中旬预约截止。</li>
      </ul>

      <h3>7月发售</h3>
      <ul>
        <li><strong>《僕の心のヤバイやつ》山田杏奈 白丝制服Ver.</strong> —— KADOKAWA出品，1/7比例，16,500日元。</li>
        <li><strong>白丝JK主题亚克力立牌套装</strong> —— Animate限定，全6种，各1,200日元。</li>
      </ul>

      <h3>8月发售</h3>
      <ul>
        <li><strong>Comic Market 104限定 白丝JK同人套装</strong> —— 多家同人社团联合出品，包含B2挂画+亚克力砖。</li>
        <li><strong>《ブルーアーカイブ》白丝JK学生系列手办第二弹</strong> —— Good Smile Company，详细价格待公布。</li>
      </ul>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=Calendar%20with%20anime%20merchandise%20new%20releases%20marked%2C%20collectible%20figures%20and%20goods%20arranged%20neatly%2C%20soft%20pink%20and%20cream%20aesthetic%20background%2C%20organized%20planner%20style%2C%20warm%20cozy%20lighting%2C%20clean%20minimal%20layout&width=1200&height=675&seq=article-limited-edition&orientation=landscape",
    date: "2026-05-05",
    author: "JK周边编辑部",
    tags: ["限定", "发售日历", "白丝", "JK", "新品"],
  },
  {
    slug: "jk-white-socks-photography-tips",
    title: "白丝JK写真拍摄技巧：在家也能拍出专业感",
    category: "tongren",
    summary: "无需专业设备，掌握光线、构图和pose技巧，在家里也能拍摄出质感出众的白丝JK主题写真。",
    content: `
      <h3>拍摄准备</h3>
      <p>拍摄一组好看的白丝JK写真并不需要昂贵的器材。一台入门级单反甚至一部旗舰手机，配合正确的光线和构图，就能拍出令人满意的作品。关键要素包括：整洁的背景、充足的自然光、以及基本的服装和道具准备。</p>

      <h3>光线运用</h3>
      <p>白丝在光线下的表现力是其魅力的关键。建议选择上午9-11点或下午3-5点的自然侧光拍摄，这个时段的光线柔和且富有层次感。逆光可以营造梦幻的氛围，顺光则能清晰展现白丝的纹理细节。避免正午的顶光拍摄，会产生难看的阴影。</p>

      <h3>构图建议</h3>
      <p>白丝JK写真的构图可以多利用对角线、三分法等经典法则。建议多拍半身和局部特写，尤其是腿部白丝的细节。低角度拍摄可以让腿部线条更加修长。同时可以加入一些小道具如书包、书本、樱花等增加画面故事感。</p>

      <h3>后期处理</h3>
      <p>后期可以选择Lightroom或手机上的VSCO、醒图等App进行调整。重点注意白丝的白色平衡，避免过曝或偏色。适度提高清晰度和锐度可以让白丝的纹理更加分明。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=Photography%20setup%20with%20camera%20and%20soft%20fabric%20textures%2C%20natural%20window%20light%2C%20minimal%20cream%20and%20blush%20pink%20aesthetic%2C%20creative%20workspace%2C%20artistic%20atmosphere%2C%20warm%20gentle%20lighting%2C%20clean%20composition&width=1200&height=675&seq=article-photography&orientation=landscape",
    date: "2026-07-02",
    author: "JK周边编辑部",
    tags: ["写真", "拍摄", "白丝", "JK", "技巧"],
  },
  {
    slug: "jk-uniform-brand-comparison",
    title: "JK制服品牌对比：日制vs国牌白丝搭配实测",
    category: "fuzhuang",
    summary: "对比日本本土JK制服品牌与国内新兴JK品牌的品质差异，包含面料、版型、价格及白丝搭配效果实测。",
    content: `
      <h3>日制JK品牌概览</h3>
      <p>日本JK制服品牌历史悠久，工艺成熟。代表品牌包括：</p>
      <ul>
        <li><strong>CONOMi：</strong>日本最大的JK制服专门品牌，设计偏向正统学院风，面料厚实挺括，价格区间8,000-20,000日元。</li>
        <li><strong>EASTBOY：</strong>以格裙闻名，版型经典，颜色选择丰富，价格6,000-15,000日元。</li>
        <li><strong>KURI-ORI：</strong>注重细节设计，格纹图案独特，价格偏高但品质出众。</li>
      </ul>

      <h3>国牌JK品牌崛起</h3>
      <p>近年来国内JK品牌发展迅速，品质大幅提升：</p>
      <ul>
        <li><strong>中牌制服馆：</strong>国内JK制服领军品牌，原创格纹设计，面料舒适，价格200-500元。</li>
        <li><strong>梗豆物语：</strong>以甜系设计为主，非常适合搭配白丝的可爱风格，价格150-400元。</li>
        <li><strong>樱花家族：</strong>注重性价比，基础款JK制服套装价格亲民，适合入门选择。</li>
      </ul>

      <h3>白丝搭配实测对比</h3>
      <p>我们分别用日制和国牌JK制服搭配同款白丝袜进行了实拍对比。结果显示：日制制服因为面料偏厚挺括，搭配白丝时轮廓更加分明；国牌制服面料偏柔软，搭配白丝时更显柔和甜美。两者各有千秋，选择取决于个人风格偏好。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=Fashion%20brand%20comparison%20flat%20lay%20of%20Japanese%20school%20uniforms%2C%20different%20styles%20and%20fabrics%20displayed%20side%20by%20side%2C%20soft%20cream%20background%2C%20minimal%20editorial%20style%2C%20warm%20lighting%2C%20clean%20professional%20photography&width=1200&height=675&seq=article-brand-compare&orientation=landscape",
    date: "2026-06-15",
    author: "JK周边编辑部",
    tags: ["品牌", "JK制服", "对比", "白丝", "实测"],
  },
  {
    slug: "white-socks-jk-beginner-guide",
    title: "白丝JK新人入坑全攻略：从零开始的收藏之路",
    category: "gouwu",
    summary: "面向刚接触白丝JK周边的新人，从品类认知、预算规划、渠道选择到防坑技巧的全面入门指南。",
    content: `
      <h3>欢迎来到白丝JK周边的世界</h3>
      <p>如果你刚刚开始对白丝JK周边产生兴趣，可能会被琳琅满目的商品和信息搞得眼花缭乱。别担心，这篇指南将帮助你理清思路，从零开始建立自己的收藏体系。</p>

      <h3>第一步：明确收藏方向</h3>
      <p>白丝JK周边涵盖的品类非常广泛，建议先确定一个或两个感兴趣的领域：</p>
      <ul>
        <li><strong>手办路线：</strong>适合喜欢立体收藏的朋友，从几百元的景品到上万元的高端雕像都有。</li>
        <li><strong>服装路线：</strong>适合想亲自体验JK穿搭的朋友，需要关注尺码、面料和搭配。</li>
        <li><strong>平面收藏：</strong>挂画、色纸、亚克力立牌等，占地面积小，入门门槛低。</li>
        <li><strong>同人作品：</strong>同人志、插画集等，更注重艺术性和稀缺性。</li>
      </ul>

      <h3>第二步：合理规划预算</h3>
      <p>建议新人从每月300-500元的预算开始，先购买几件心仪的单品积累经验。切忌一开始就大量购买，容易买到不合适的商品造成浪费。随着经验的增长，再逐步提高预算。</p>

      <h3>第三步：加入社群交流</h3>
      <p>加入贴吧、QQ群、微信群等JK周边爱好者社群，可以获取最新的发售资讯、购买渠道推荐，还能和其他爱好者交流心得。推荐关注微博超话「JK日常」和B站相关UP主。</p>
    `,
    coverImage: "https://readdy.ai/api/search-image?query=Beginner%20guide%20concept%20with%20anime%20merchandise%20items%20and%20notebook%2C%20warm%20cozy%20desk%20scene%2C%20soft%20cream%20and%20pink%20aesthetic%2C%20organized%20study%20space%2C%20gentle%20natural%20light%2C%20welcoming%20atmosphere&width=1200&height=675&seq=article-beginner&orientation=landscape",
    date: "2026-04-18",
    author: "JK周边编辑部",
    tags: ["新人", "入门", "指南", "白丝", "JK"],
  },
];

export const faqItems = [
  {
    question: "白丝JK手办的推荐购买渠道有哪些？",
    answer: "推荐通过日本直邮渠道如Amiami、HobbySearch购买，价格透明且保证正品。国内渠道推荐Bilibili会员购、Hpoi和电玩男。淘宝上建议选择皇冠级信誉的日本代购店铺，并注意查看买家评价。",
  },
  {
    question: "如何辨别白丝JK手办的真伪？",
    answer: "主要从五个方面辨别：包装盒印刷质量、涂装细节（特别是白丝部分）、底座logo与编号、价格是否过低、以及购买渠道是否可靠。正版白丝部分会有自然的阴影层次，而仿品通常是一片死白。",
  },
  {
    question: "JK制服搭配白丝有哪些注意事项？",
    answer: "首先注意白丝的长度选择，过膝袜是最经典的搭配；其次根据季节选择材质，夏季推荐包芯丝，冬季可选天鹅绒；最后注意色彩协调，白色丝袜搭配深色制服效果最佳，避免与过浅的裙子搭配造成色调单一。",
  },
  {
    question: "白丝JK同人志在哪里可以买到？",
    answer: "日本渠道推荐Melonbooks、虎穴（Toranoana）和BOOTH。国内可以通过同人代购或B站工坊、CPP（COMICUP）等平台购买。建议关注画师的Twitter和Pixiv账号获取最新发售信息。",
  },
  {
    question: "新手入坑白丝JK周边需要准备多少预算？",
    answer: "建议从每月300-500元起步。景品类手办约200-800元，比例手办600-2000元不等，JK制服套装200-800元。建议先从小件商品如亚克力立牌、色纸等开始，逐步建立收藏。",
  },
  {
    question: "白丝JK主题的Cosplay服装如何选购？",
    answer: "Cosplay服装建议选择淘宝上的专业C服定制店铺，注意查看面料和做工评价。白丝袜可以选择Tutuanna或厚木等品牌的正品，质感明显优于普通白丝。假发推荐漫美、主宰者等品牌。",
  },
];

export const testimonials = [
  {
    name: "小樱花",
    role: "手办收藏爱好者",
    content: "关注这个网站半年了，通过上面的购买指南成功避开了好几个山寨手办的坑，非常感谢！推荐的白丝JK手办TOP10榜单太实用了。",
    avatar: "https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%2C%20soft%20pastel%20colors%2C%20simple%20clean%20background%2C%20kawaii%20illustration%20style&width=100&height=100&seq=avatar-1&orientation=squarish",
  },
  {
    name: "制服控阿星",
    role: "JK制服博主",
    content: "JK制服搭配白丝的指南写得太专业了！从面料到品牌的全方位对比，帮我省了不少试错成本。已经推荐给粉丝们了。",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20with%20brown%20hair%20and%20glasses%2C%20soft%20warm%20colors%2C%20simple%20background%2C%20kawaii%20illustration%20style&width=100&height=100&seq=avatar-2&orientation=squarish",
  },
  {
    name: "绘梦师Lin",
    role: "同人画师",
    content: "作为同人创作者，很喜欢这个网站对同人文化的深度解读。推荐的画师作品和购买渠道都很靠谱，已经在这里种草了好几本同人志。",
    avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20with%20silver%20hair%2C%20artistic%20vibe%2C%20soft%20pastel%20colors%2C%20simple%20background%2C%20kawaii%20illustration%20style&width=100&height=100&seq=avatar-3&orientation=squarish",
  },
];

export const siteInfo = {
  name: "白丝JK正版周边",
  tagline: "最懂你的JK白丝周边指南",
  description: "白丝jk是二次元文化中极具人气的角色形象与服饰风格，本页汇聚白丝jk相关正版周边、手办、服装及同人文化资讯，帮助爱好者快速找到高品质白丝jk周边产品与购买渠道，了解其在动漫文化中的流行背景。",
  keywords: "白丝jk,白丝jk周边,白丝jk手办,白丝jk服装,jk制服白丝搭配,二次元白丝jk,白丝jk同人文化",
  email: "contact@shiroi-jk.com",
  wechat: "shiroi_jk_official",
  weibo: "@白丝JK周边指南",
  bilibili: "白丝JK周边指南",
};